"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TIMEOUT = exports.PENDING = exports.FAILURE = exports.SUCCESS = void 0;
var SUCCESS = 'SUCCESS';
exports.SUCCESS = SUCCESS;
var FAILURE = 'FAILURE';
exports.FAILURE = FAILURE;
var PENDING = 'PENDING';
exports.PENDING = PENDING;
var TIMEOUT = 'TIMEOUT';
exports.TIMEOUT = TIMEOUT;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-rhumb/static-1.5065/js/internal/ResultStatus.js
// module id = 623
// module chunks = 209 210 211 212